import axios from 'axios'
import _ from 'lodash'

class UploadDigitalAsset {
  async create_digital_asset(file, digital_asset_params, base_path, authorization) {
    const params = _.merge(digital_asset_params, { name: file.name })
    const response = await axios({
      url: `${base_path}/digital_assets`,
      method: 'post',
      data: {
        digital_asset: params,
        timestamp: new Date().getTime(),
        fields: ['signature']
      },
      headers: {
        Authorization: `Bearer ${authorization}`
      }
    })
    return await response.data
  }

  async add_external_video(external_video_url, external_video_source, base_path, authorization) {

    const params = {
      name: 'External Video',
      external_video_url: external_video_url.trim(),
      source: external_video_source
    }
    
    const response = await axios({
      url: `${base_path}/digital_assets`,
      method: 'post',
      data: {
        digital_asset: params,
        timestamp: new Date().getTime(),
        fields: ['oembed_html','external_video_poster']
      },
      headers: {
        Authorization: `Bearer ${authorization}`
      }
    })

    return await response.data
  }
}

export default new UploadDigitalAsset()
